/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OloError
 */
export interface OloError {
    /**
     * 
     * @type {string}
     * @memberof OloError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof OloError
     */
    num: number;
    /**
     * 
     * @type {number}
     * @memberof OloError
     */
    optionid?: number;
    /**
     * 
     * @type {number}
     * @memberof OloError
     */
    productid?: number;
}

/**
 * Check if a given object implements the OloError interface.
 */
export function instanceOfOloError(value: object): value is OloError {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('num' in value) || value['num'] === undefined) return false;
    return true;
}

export function OloErrorFromJSON(json: any): OloError {
    return OloErrorFromJSONTyped(json, false);
}

export function OloErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OloError {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'num': json['num'],
        'optionid': json['optionid'] == null ? undefined : json['optionid'],
        'productid': json['productid'] == null ? undefined : json['productid'],
    };
}

export function OloErrorToJSON(json: any): OloError {
    return OloErrorToJSONTyped(json, false);
}

export function OloErrorToJSONTyped(value?: OloError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'num': value['num'],
        'optionid': value['optionid'],
        'productid': value['productid'],
    };
}

